import React from 'react';
import { Layout, ConfigProvider, Spin } from 'antd';
import { AuthProvider, useAuth } from './features/auth/contexts/AuthContext';
import Login from './features/auth/components/Login';
import DebtTracker from './features/debt-management/components/DebtTracker/DebtTracker';
import Header from './components/layout/Header';
import viVN from 'antd/locale/vi_VN';
import 'dayjs/locale/vi';
import dayjs from 'dayjs';
import './assets/styles/globals.css';

dayjs.locale('vi');

const { Content } = Layout;

function AppContent() {
  const { currentUser, loading } = useAuth();

  // Hiển thị loading khi đang kiểm tra auth
  if (loading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh'
      }}>
        <Spin size="large" />
      </div>
    );
  }

  // Hiển thị login nếu chưa đăng nhập
  if (!currentUser) {
    return <Login />;
  }

  // Hiển thị app chính nếu đã đăng nhập
  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header />
      <Content style={{ background: '#f0f2f5' }}>
        <DebtTracker />
      </Content>
    </Layout>
  );
}

function App() {
  return (
    <ConfigProvider locale={viVN}>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </ConfigProvider>
  );
}

export default App;
